import React, { useContext, useEffect } from "react";
import LeadDetailReadOnlyContext from "contexts/LeadDetailReadOnlyContext";
import { DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, UncontrolledDropdown } from "reactstrap";
import PropTypes from 'prop-types';
import Select from 'react-select';
import { useState } from "react";
import { wordBreakWithSpace } from "helpers/sf_leads_calls_helper";
import { allowOnlyNumberandDot, getOptionFromValueForSelectBox, getPrimaryButtonClass } from "helpers/sf_utils";

const LeadEditDropdown = props => {
    const isReadOnly = useContext(LeadDetailReadOnlyContext) || props?.isReadOnly;
    const [fieldInput, setFieldInput] = useState(props?.field);
    const [selectedGroup, setselectedGroup] = useState(props?.options?.find(e => e.value == props?.field) || getOptionFromValueForSelectBox(props?.options, props?.defaultValue) || null)
    const [isEditable, setIsEditable] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [isMouseDown, setIsMouseDown] = useState(false)


    useEffect(() => {
        if (props?.field) {
            setFieldInput(props?.field)
            setselectedGroup(props?.options?.find(e => e.value == props?.field) || null)
        }
    }, [props?.field]);

    function handleSelectGroup(selectedGroup) {
        setselectedGroup(selectedGroup)
        setFieldInput(selectedGroup)
    }
    const getFieldToDisplay = (isBoolean, field, defaultValue, isInput, iscurrentlyInsured, isContinuousCoverage) => {
        if (isBoolean) {
            if (field === true) {
                return 'Yes';
            } else if (field === false) {
                return 'No';
            } else {
                return '--';
            }
        }
        else if (isInput) {
            let displayValue;
            if (!iscurrentlyInsured && isContinuousCoverage || (field === '')) {
                displayValue = '--';
            }
            else if (field < 1 && field > 0) {
                displayValue = 'Less than 1 year';
            }
            else if (field == 0) {
                displayValue = 'Less than 1 year';
            } else {
                if (field == 1) {
                    displayValue = '1 Year';
                } else if (field > 1) {
                    displayValue = `${field} Years`;
                } else {
                    displayValue = defaultValue || '--';
                }
            }
            return displayValue;
        }
        else {
            if (field) {
                return wordBreakWithSpace(field);
            } else {
                return defaultValue || '--';
            }
        }
    }

    const toggle = () => {
        setIsOpen(!isOpen);
        if (isOpen) {
            // Reset fieldInput to original value on cancel
            setFieldInput(props?.field);
        }
    }

    if (isReadOnly) {
        return (
            <p className="mb-0 fsnormal text-black me-1">
                {getFieldToDisplay(props?.isBoolean, props?.field, props?.isProspect ? props?.field : props?.defaultValue, props?.isInput, props?.currentlyInsured, props?.isContinuousCoverage)}
            </p>
        );
    }

    return (
        <React.Fragment>
            <UncontrolledDropdown isOpen={isOpen}
                onToggle={(event, isOpen) => {
                    if (!isMouseDown && isOpen) {
                        toggle()
                    } else if (isMouseDown && isOpen) {
                        setIsMouseDown(false);
                    }
                    else if (!isOpen) {
                        setIsMouseDown(false);
                        setIsOpen(true)
                    }
                }}
                onMouseDown={(e) => setIsMouseDown(true)}
                onMouseUp={(e) => setIsMouseDown(false)}>
                <DropdownToggle
                    href="#"
                    className='nav-link py-0 px-0'
                    tag="i"
                >
                    <div className="d-flex"
                        onMouseEnter={(e) => {
                            setIsEditable(true);
                        }}
                        onMouseLeave={(e) => {
                            setIsEditable(false);
                        }}
                    >
                        <p className="mb-0 fsnormal text-black me-1" onMouseEnter={(e) => { setIsEditable(true) }} onMouseLeave={(e) => { setIsEditable(false) }}>
                            {getFieldToDisplay(props?.isBoolean, props?.field, props?.isProspect ? props?.field : props?.defaultValue, props?.isInput, props?.currentlyInsured, props?.isContinuousCoverage)}
                        </p>
                        {isEditable === true ?
                            <i
                                className="font-size-13 mdi mdi-pencil text-success"
                            /> :
                            <div className="edit-hover-class">
                                <a ><i
                                    className="font-size-13 mdi mdi-pencil text-success"
                                />
                                </a>
                            </div>
                        }
                    </div>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-start">
                    <DropdownItem className="font-weight-semibold">{props?.title}</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem text>
                        <div className="d-flex flex-column">
                            <div>
                                {props.isDropdown ?
                                    <FormGroup className="sf-box-w">
                                        <Select
                                            menuPlacement={props.menuPlacement || "bottom"}
                                            maxMenuHeight={200}
                                            value={selectedGroup}
                                            onChange={handleSelectGroup}
                                            options={props.options}
                                            placeholder="Select"
                                            classNamePrefix="select2-selection"
                                        />
                                    </FormGroup>
                                    :
                                    <Input
                                        className="form-control sf-box-w"
                                        type={"text"}
                                        value={fieldInput}
                                        autoFocus={true}
                                        onChange={(e) => {
                                            e.persist();
                                            if (props?.isProspect || !props?.isInput) {
                                                setFieldInput(e.target.value);
                                                return;
                                            }
                                            const validInput = allowOnlyNumberandDot(e.target.value);
                                            if (validInput || validInput === '') {
                                                if (!validInput.includes('.')) {
                                                    setFieldInput(validInput.slice(0, 2));
                                                }
                                                else {
                                                    setFieldInput(validInput)
                                                }
                                            }
                                        }}
                                    />
                                }
                            </div>
                            <div className="d-flex align-items-center ms-auto mt-2">
                                {props.isDropdown ?
                                    <button
                                        className={`btn btn-sm ${getPrimaryButtonClass()} mx-1`}
                                        name="saveName"
                                        onClick={() => {
                                            props.onSave(fieldInput.value)
                                            toggle()
                                        }}
                                    >
                                        Save
                                    </button>
                                    :
                                    <button
                                        className={`btn btn-sm ${getPrimaryButtonClass()} mx-1`}
                                        name="saveName"
                                        onClick={() => {
                                            props.onSave(fieldInput.trim())
                                            toggle()
                                        }}
                                    >
                                        Save
                                    </button>

                                }
                                <button className="btn btn-sm btn-light mx-1" name="resetName" onClick={toggle}>Cancel</button>
                            </div>
                        </div>
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        </React.Fragment>
    )
}

LeadEditDropdown.propTypes = {
    title: PropTypes.any,
    menuPlacement: PropTypes.string,
    field: PropTypes.string,
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    isDropdown: PropTypes.bool,
    isBoolean: PropTypes.bool,
    options: PropTypes.array,
    defaultValue: PropTypes.string,
}

export default LeadEditDropdown